export default __webpack_public_path__ + "static/media/3.411877c1.png";